export default class PermissionsService {
  constructor (Api) {
    this.api = Api;
  }

  getPermissionsList () {
    return this.api.get('permissions');
  }
}
